export default {
  navigateToHome: (router, onComplete = null, onAbort = null) => {
    router.push({ path: "/" }, onComplete, onAbort)
  },
  navigateToSignIn: (router, onComplete = null, onAbort = null) => {
    router.push({ path: "/signin" }, onComplete, onAbort)
  },
  navigateToUnauthorized: (router, onComplete = null, onAbort = null) => {
    router.push({ path: "/unauthorized" }, onComplete, onAbort)
  },
  navigateToPath: (router, path, onComplete = null, onAbort = null) => {
    router.push({ path }, onComplete, onAbort)
  },
  matchRouteWithSingInPath: (route) => {
    return route.path === "/signin"
  },
  navigateToAccessDenied: (router, onComplete = null, onAbort = null) => {
    router.push({ path: "/403" }, onComplete, onAbort)
  },
}
